import { useState } from "preact/hooks";
import User from "../../../../services/user";
import Observer from "../../utils/observer";
import { Trans } from "@lingui/react/macro";
import CasinoService from "../../../../services/casino-feed";


export function EmbeddedMinigame() {
	const [opened, setOpen] = useState(false);
	const logged = User.isLogged() && !User.isAffiliate();

	const handleOpen = () => {
		if (logged) {
			setOpen(true)
		} else {
			Observer.notify('open-user-signup');
		}
	}

	if (!opened || !logged)
		return <div class="w-full h-[400px] flex items-center justify-center bg-[#303030]">
			<div class="w-[250px] h-[370px] flex items-center justify-center relative cursor-pointer" onClick={handleOpen}>
				<img src={require("url:../../assets/img/casino/halloween-preview-blur.png")} class="absolute h-full w-full" />
				<button class="relative z-10 overflow-hidden px-3 py-2 bg-gradient-to-r from-purple-600 to-orange-500 text-white font-extrabold text-base uppercase tracking-widest rounded-lg border-2 border-orange-400 shadow-xl hover:-translate-y-1 hover:shadow-orange-500/50 transition-all duration-200 group">
					<div class="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1s_forwards] bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12"></div>
					<span class="relative flex items-center gap-2 drop-shadow-md">
						<Trans>Play</Trans>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
							<path fill-rule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 20.046c-1.25.687-2.779-.217-2.779-1.643V5.653z" clip-rule="evenodd" />
						</svg>
					</span>
				</button>
			</div>
		</div>
	return <div class="w-full h-[400px] bg-[#303030]">
		<iframe src={CasinoService.getPlayUrl('Aviator', 'aviator', 'halloween-party-mini')} class="h-full w-full"></iframe>
	</div>
}
